<div class="signup-content" id="scroll-to-top-ref">
  <div class="signup">

    <div class="signup__header animated fadeInDown">
      <div class="container my-3">
        <a routerLink="/home">
          <img class="signup__logo" src="/assets/images/logo.svg?v={{logoVersionNumber()}}" alt="Farmbox - Logo">
        </a>
      </div>
    </div>

    @if (isLoadingContent() || accountService.isLoading() || isWaitingResponse()) {
    <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
    }

    @if (isLoadedMarketingValidations() || isTryingToApplyCoupon()) {
    <div class="alert position-sticky top-0 alert-success border-0 z-1020 fade show animated fadeInUp rounded-0"
      [class.animated]="!isTryingToApplyCoupon()" role="alert">
      <div class="d-flex justify-content-center align-items-center gap-3">

        @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
        <section
          class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
          <section class="d-flex align-items-center gap-2 justify-content-center">
            <i class="fas fa-tag"></i>
            <strong>Discount successfully applied!</strong>
          </section>
          <section class="d-flex align-items-center gap-2 justify-content-center">
            <i class="fw-semibold">({{signupPromotionInfo().code}})</i>
            {{signupPromotionInfo().name}}
          </section>
          <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
            (click)="clearSignupPromotionInfo()" ngbTooltip="Change Coupon Code">
            <i class="fas fa-sync"></i>
            <a href="javascript:void(0)" class="link-color">
              Change Coupon
            </a>
          </section>
        </section>
        } @else {
        <section
          class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
          <section class="d-flex align-items-center gap-2 justify-content-center">
            <i class="fas fa-tag"></i>
            <strong class="text-nowrap">Have a coupon? Apply it here:</strong>
          </section>
          <section class="d-flex align-items-center gap-3">
            <input type="text" class="form-control form-control-sm" placeholder="Coupon Code" #signupCouponCode
              (keyup.enter)="applySignupCoupon(signupCouponCode.value)">

            <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
              (click)="applySignupCoupon(signupCouponCode.value)">
              <i class="fas fa-check"></i>
              <a href="javascript:void(0)" class="link-color">
                Apply
              </a>
            </section>

            @if (signupPromotionInfoFromLS()?.code && signupPromotionInfoFromLS()?.name) {
            or

            <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
              (click)="restoreSignupInfo()">
              <i class="fas fa-times"></i>
              <a href="javascript:void(0)" class="link-color">
                Cancel
              </a>
            </section>

            }
          </section>
        </section>
        }

      </div>
    </div>
    }

    <div class="d-flex flex-column align-items-center">
      <div class="{{this.matStepper().selectedIndex !== 2 ? 'signup__body' : 'signup__body-step-2'}} animated fadeInUp">
        <h2 class="h2-semibold d-flex justify-content-center text-center">
          Get Started with Farmbox Delivery
        </h2>
        <div class="container-fluid">

          <mat-stepper [linear]="true" [disableRipple]="true" #stepper class="animated fadeIn">

            <mat-step #farmboxStep [completed]="false" [editable]="false" label="Select Your Farmbox">
              <div class="animated fadeIn">
                <app-farmbox-choosing-signup [stepper]="matStepper()" [subscriptionCard]="bundleProducts()"
                  [productDetails]="productDetails()" (outProductSelected)="farmboxStep.completed = true"
                  (onNextStep)="continue()" (outComponentReady)="onProductCardReady($event)"
                  (onProductCardHover)="onProductCardHover($event)">
                </app-farmbox-choosing-signup>
              </div>
            </mat-step>

            <mat-step #firstStep [completed]="false" [editable]="false" label="Delivery Information">
              <div>
                <app-check-address-signup [stepper]="matStepper()" [firstStep]="firstStep"
                  (deliveryAddressChanged)="deliveryAddressInformation = $event"
                  (selectedDayChanged)="deliverySelectedDay = $event"
                  (deliveryOptionChanged)="deliveryOptionSelected = $event" (onNextStep)="continue()">
                </app-check-address-signup>
              </div>
            </mat-step>

            <mat-step #personalInfoStep [completed]="false" [editable]="false" label="Personal Information">
              <app-personal-information-signup #personalInformationComponent [stepper]="matStepper()"
                [firstStep]="firstStep" (formValidityChanged)="formValidityPersonalInformation = $event"
                (personalInformationChanged)="personalInformationData = $event"
                [peopleOptions]="personalInformation()?.peopleShoppingFor"
                [dietaryRestrictions]="personalInformation()?.dietaryRestrictions" [referralSources]="referralSource"
                (dietaryChanged)="dietaryRestrictionsValues = $event" (onNextStep)="createNewClient()">
              </app-personal-information-signup>
            </mat-step>

            <mat-step #paymentMethodStep [completed]="false" [editable]="false" label="Payment Information">
              <div>
                <app-payment-method-signup (formValidityChanged)="formValidityPaymentMethod = $event"
                  (out_continue)="continue()">
                </app-payment-method-signup>
              </div>
            </mat-step>

          </mat-stepper>
        </div>
      </div>
    </div>

  </div>
  <app-faqs [step]="matStepper()?.selectedIndex ?? 0"></app-faqs>
  <app-footer></app-footer>
</div>